import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { PastVoyagesComponent } from '../past-voyages/past-voyages.component';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-update-table',
  templateUrl: './update-table.component.html',
  styleUrls: ['./update-table.component.scss'],
})
export class UpdateTableComponent implements OnInit {
  selectedTab: boolean = true;
  @ViewChild('pastVoyages') pastVoyagesComponent!: PastVoyagesComponent;
  constructor(private requestFormService: RequestFormService) {
    this.selectedTab = true;
  }

  ngOnInit(): void {
    this.selectedTab = true;
  }
  tabChanged(event: MatTabChangeEvent) {
    this.selectedTab = !this.selectedTab;
    if (this.pastVoyagesComponent) {
      this.pastVoyagesComponent.refresh();
    }
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
